module.exports = __webpack_public_path__ + "img/car_bg1.aec8b461.png";